<template>
  <ArticleCard
    v-if="article.type === 'ARTICLE'"
    :article="article"
    :breadcrumb="withBreadcrumb"
  />
  <YoutubeCard
    v-else-if="article.type === 'YOUTUBE'"
    :article="article"
  />
  <CollectionCard
    v-else-if="article.type === 'COLLECTION'"
    :article="article"
  />
</template>

<script>
import ArticleCard from 'components/layout/help/cards/ArticleCard'
import YoutubeCard from 'components/layout/help/cards/YoutubeCard'
import CollectionCard from 'components/layout/help/cards/CollectionCard'

export default {
  components: {
    ArticleCard, YoutubeCard, CollectionCard
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    withBreadcrumb: {
      type: Boolean,
      default: false
    }
  }
}
</script>
